const BrandMark = () => (
  <span className="inline-flex">
    <img src="/logo.svg" alt="Varikanakku" className="h-20 w-auto" />
  </span>
);

export default BrandMark;
